import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders, HttpParams} from '@angular/common/http';
import {map, Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {User} from '../models/users';
import {environment} from '../environments/enviroment';


@Injectable({
  providedIn: 'root'
})
export class AgentStateManagerService {

  private stateManagerUrl = `${environment.mindxbkUrl}StateAdministrator/`;

  constructor(
    private http: HttpClient) {

  }

  setAgentState(agentId: string, state: string): Observable<User> {
    const token = localStorage.getItem('auth_req');
    if (!token) {
      console.error('❌ No se encontró token en localStorage (auth_req)');
      return throwError(() => new Error('No auth token available'));
    }

    const headers = new HttpHeaders({
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });

    const url = `${this.stateManagerUrl}agent/${agentId}/status`;
    const params = new HttpParams().set('status', state);

    return this.http.patch<User>(url, {}, {headers, params}).pipe(
      map(response => response),
      catchError((error: HttpErrorResponse) => {
        console.error('Error setting agent state:', error);
        return throwError(() => new Error('Failed to set agent state'));
      })
    );
  }

  closeAgentState(agentId: string): Observable<void> {
    const token = localStorage.getItem('auth_req');
    if (!token) {
      console.error('❌ No se encontró token en localStorage (auth_req)');
      return throwError(() => new Error('No auth token available'));
     }
    const headers = new HttpHeaders({
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });
    const url = `${this.stateManagerUrl}agent/${agentId}/close`;
    return this.http.patch<void>(url, {headers}).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('Error closing agent state:', error);
        return throwError(() => new Error('Failed to close agent state'));
      })
    );

  }

  getAgentState(): Observable<string[]> {
    const token = localStorage.getItem('auth_req');
    if (!token) {
      console.error('❌ No se encontró token en localStorage (auth_req)');
      return throwError(() => new Error('No auth token available'));
    }

    const headers = new HttpHeaders({
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });

    const url = `${this.stateManagerUrl}states`;

    return this.http.get<string[]>(url, {headers}).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('Error fetching agent states:', error);
        return throwError(() => new Error('Failed to fetch agent states'));
      })
    );
  }

  getLocalAgentState(): string | null {
    const agentState = localStorage.getItem('status_agent');
    if (agentState) {
      return agentState;
    } else {
      console.warn('❗ No se encontró el estado del agente en localStorage');
      return null;
    }
  }

  reInitializeAgentState(agent_id: string): void {
    const currentState = this.getLocalAgentState();

    if(!currentState) {
      console.warn('❗ No se pudo re-inicializar el estado del agente porque no se encontró el estado actual');
      return;
    }

    this.setAgentState(agent_id, currentState).subscribe({
      next: (response) => {
        // console.log('✅ Estado del agente re-inicializado correctamente:', response);
      },
      error: (error) => {
        console.error('❌ Error al re-inicializar el estado del agente:', error);
      }
    });
  }
}
